import instance from "@/plugins/axios";
import { ResponseResult } from "@/core/models/response-result";
import {
  AbstractDashboardRemoteDataSource,
  GetCalendarDataParams,
  GetOccupancyDataParams,
} from "@/modules/dashboard/remote/AbstractDashboardRemoteDataSource";
import { EventCalendarModel } from "@/core/models/event-calendar-model";
import { EventState } from "@/modules/events/models/event-state";
import { DashboardOccupancyModel } from "../models/dashboard-occupancy-model";
import { ExecutiveDashboardRemoteDataSource } from "@/modules/executiveDashboard/remote/ExecutiveDashboardRemoteDataSource";

export class DashboardRemoteDataSource
  implements AbstractDashboardRemoteDataSource
{
  async getCalendarData(
    params: GetCalendarDataParams,
  ): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult>("Events/dashboard/calendar", {
          params,
        })
      ).data;
      if (!response.isSuccess) return response;
      response.data = this.convertFromJsonToEventCalendarModelList(
        response.data.months,
      );
      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  async getOccupancyData(
    params: GetOccupancyDataParams,
  ): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult<any>>("Events/dashboard/occupancy", {
          params,
        })
      ).data;
      if (!response.isSuccess) return response;
      response.data = this.convertFromJsonToDashboardOccupancyModel(
        response.data,
      );
      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  convertFromJsonToEventCalendarModelList(data: any[]): EventCalendarModel[] {
    return data.map((item) => this.convertFromJsonToEventCalendarModel(item));
  }

  convertFromJsonToEventCalendarModel(data: any): EventCalendarModel {
    return {
      year: data.year,
      month: data.month,
      quantity: data.quantity,
      events: data.events.map((item: any) => {
        return {
          eventId: item.eventId,
          name: item.name,
          status: EventState.getEventStateByValue(item.status),
          interval: {
            startDate: item.interval.startDate,
            endDate: item.interval.endDate,
          },
        };
      }),
    };
  }

  convertFromJsonToDashboardOccupancyModel(data: any): DashboardOccupancyModel {
    return {
      usedResources:
        ExecutiveDashboardRemoteDataSource.convertFromJsonToDashBoardEntry(
          data.usedResources,
        ),
      occupation:
        ExecutiveDashboardRemoteDataSource.convertFromJsonToDashBoardEntry(
          data.occupation,
        ),
      averageAssembly:
        ExecutiveDashboardRemoteDataSource.convertFromJsonToDashBoardEntry(
          data.averageAssembly,
        ),
      resources: data.timeline.resources.map((item: any) => {
        return {
          resourceId: item.resourceId,
          name: item.name,
          intervals: item.intervals.map((interval: any) => {
            return {
              quantity: interval.quantity,
              eventId: interval.eventId,
              name: interval.name,
              bars: interval.bars.map((bar: any) => {
                return {
                  startDate: bar.startDate,
                  endDate: bar.endDate,
                };
              }),
            };
          }),
        };
      }),
    };
  }
}
